import { useState, useEffect } from 'react';

/**
 * Returns true one frame after `activeTab` matches `tab`, so the tab chrome can paint first.
 */
export default function useDeferredTabPanel(tab, activeTab) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (activeTab !== tab) {
      setReady(false);
      return undefined;
    }
    setReady(false);
    const frame = requestAnimationFrame(() => {
      setReady(true);
    });
    return () => cancelAnimationFrame(frame);
  }, [tab, activeTab]);

  return activeTab === tab && ready;
}
